import type { ReportValueType } from '~/presentation/reports/common/type';

import { useConvertMoneyByCurrency } from '~/modules/shopify';
import { formatReportData } from '../utils';

export const useReportData = () => {
  const { getTextPrice } = useConvertMoneyByCurrency();

  const formatData = ({
    value,
    formatter,
    name,
  }: {
    value: ReportValueType;
    formatter?: string;
    name: string;
  }): ReportValueType => {
    return formatReportData({
      value,
      formatter,
      getTextPrice,
      name,
    });
  };

  return {
    formatData,
  };
};
